import React, { Component } from 'react';
import './index.css';
import Vedio from '../Video/index';
import Split_line from '../Split-line/index';
import SwiperBanner from '../SwiperBanner/index';

export default class Middler extends Component {
    render() {
        return (
            <div className='middle-part'>
                {/* 视频部分 */}
                <Vedio />

                {/* 游戏特色分割线 */}
                <Split_line />

                {/* 轮播图部分 */}
                <SwiperBanner />
            </div>
        )
    }
}
